<div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Encargados</div>
    </div>
    <mat-form-field>
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field>
    <div class="contenedor-tabla">
        <mat-table
            class="servicios-tabla"
            #table
            [dataSource]="dataSource"
            matSort
            matSortActive="rut"
            matSortDisableClear
            matSortDirection="desc"
            [@animateStagger]="{ value: '50' }"
            fusePerfectScrollbar
        >
            <ng-container matColumnDef="rut">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Rut</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    {{ encargado.rut }}
                    <button
                        *ngIf="esRepresentante || esSupervisor"
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="editar(encargado)"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Nombre</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    <p>
                        {{ encargado.nombres }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="apellido">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Apellido
                </mat-header-cell>
                <mat-cell *matCellDef="let encargado">
                    <p>
                        {{ encargado.apellidos }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cotizar">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Cotizar</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    <p>
                        {{ encargado.permisos.puedeCotizar ? "Si" : "No" }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="comprar">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Comprar</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    <p>
                        {{ encargado.permisos.puedeComprar ? "Si" : "No" }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="recibir">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Recibir</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    <p>
                        {{ encargado.permisos.puedeRecibir ? "Si" : "No" }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="borrar" *ngIf="esRepresentante || esSupervisor">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Borrar</mat-header-cell
                >
                <mat-cell *matCellDef="let encargado">
                    <button
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="borrar(encargado.rut)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>

            <mat-row *matRowDef="let encargado; columns: displayedColumns">
            </mat-row>
        </mat-table>
        <mat-paginator
            #paginator
            [length]="dataSource?.filteredData?.length"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
    </div>
</div>
